import PropTypes from 'prop-types';

import Header from './Header';
import Body from './Body';

const Sidebar = ({
  timebar,
  tracks,
  toggleTrackOpen,
  sticky,
  clickTrackButton,
}) => (
  <div className=" border border-r-4 bg-white ">
    <Header timebar={timebar} sticky={sticky} />
    <Body
      tracks={tracks}
      toggleTrackOpen={toggleTrackOpen}
      clickTrackButton={clickTrackButton}
    />
  </div>
);

Sidebar.propTypes = {
  timebar: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
    }).isRequired
  ).isRequired,
  tracks: PropTypes.arrayOf(PropTypes.shape({})),
  toggleTrackOpen: PropTypes.func,
  sticky: PropTypes.shape({}),
  clickTrackButton: PropTypes.func,
};

export default Sidebar;
